var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_32",
    "data-name": "Grupo 32",
    transform: "translate(-386 -611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    transform: "translate(386 611)",
    fill: "#fff",
    stroke: "#c7c7c7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 25,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.55 618.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect887",
    d: "M224.833,42.3h5.622v9.183h-5.622Z",
    transform: "translate(-218.194 -41.051)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889",
    d: "M7.218,5.914a5.83,5.83,0,0,1,2.23-4.591,5.84,5.84,0,1,0,0,9.183,5.83,5.83,0,0,1-2.23-4.592Z",
    transform: "translate(0 -0.075)",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M617.423,312.93v-.188h.081V312.7h-.193v.039h.076v.188Zm.375,0V312.7h-.058l-.068.162-.068-.162h-.058v.227h.042v-.172l.063.148h.044l.063-.148v.172Z",
    transform: "translate(-599.083 -303.472)",
    fill: "#f79e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path893",
    d: "M329.434,5.839a5.84,5.84,0,0,1-9.449,4.591,5.84,5.84,0,0,0,0-9.183,5.84,5.84,0,0,1,9.449,4.591Z",
    transform: "translate(-310.536)",
    fill: "#f79e1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ee2bc8c22d28f1e129068e3e8b347856.svg";
export { ForwardRef as ReactComponent };